import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_lastSlip',
    templateUrl: './print_lastSlip.html',
})
export class PrintLastSlip implements OnInit {
    constructor(public tournamentsService: TournamentsService) {
        SetLanguage('', '');
    }
    init: boolean;
    ngOnInit() {
        SetLanguage('', '');
        if (this.init) return;
        this.init = true;
    }
    LastSlipControlModal_Button_No() {
        $('#LastSlipControlModal').modal('hide');
    }
}
